/* eslint-disable @typescript-eslint/explicit-function-return-type */
/* eslint-disable multiline-ternary */
import { Box, Button, CircularProgress, Grid, Modal, Typography } from '@mui/material'
import Water_Merlin from '../../../assets/devices/DeviceImg_WaterMerlinNBOT.svg'
import Q600 from '../../../assets/devices/DeviceImg_Q600.svg'
import { type AssetByIdState } from '../redux/slices/assetByIdSlice'
import DeviceUtil from '../../../utils/DeviceUtil'
import DefaultImage from '../../../assets/devices/No-Image-Placeholder.svg'
import HBG3 from '../../../assets/devices/DeviceImg_HBG3.svg'
import V200H from '../../../assets/devices/DeviceImg_V200H.svg'
import GASNXCM from '../../../assets/devices/DeviceImg_NXCM_AC250.svg'
import GASEI6 from '../../../assets/devices/DeviceImg_GasEi6.png'
import GASEI7 from '../../../assets/devices/DeviceImg_GasEi7.png'
import Y290 from '../../../assets/devices/DeviceImg_Y290.png'
import Contazara from '../../../assets/devices/DeviceImg_Contazara.png'
import TSherpaBridge from '../../../assets/devices/DeviceImg_TSherpaBridge.png'
import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react'
import AC250_NXS from '../../../assets/devices/DeviceImg_AC250-NXS.png'
import LanguageStrings from '../../../i18n/locales'
import AuthError from '../../../components/ErrorComponents/AuthError'
import { type RootState } from '../../../store'
import { type ConnectedProps, connect, useSelector } from 'react-redux'
import { fetchAssetData, fetchAssetImageByName, fetchDeviceHistory } from '../redux/actionCreator'
import { type IPConfigState } from '../redux/slices/ipConfigSlice'
import { getOperationPermissions } from '../../dashboard/redux/actionCreator'
import { type OperationPermissionState } from '../../dashboard/redux/operationPermissionSlice'
import { useAuth } from 'react-oidc-context'
import CloseIcon from '@mui/icons-material/Close'
import { type DeviceHistory } from '../services/deviceLifeCycleHistoryService'
import { type DeviceHistoryState } from '../redux/slices/deviceLifeCycleHistorySlice'
import { convertDateIntoAohStandardInUTC, parseDateInAOHstandard } from '../../../customHooks/parseDate'
import { type AssetPropertiesByIdState } from '../redux/slices/assetPropertiesByIdSlice'
import { type AssetPreviewDataState } from '../redux/slices/assetPreviewImagesSlice'
import AssetCarousel from './assetCarousel/AssetCarousel'

const assetValuesStyles = {
  color: '#F0F0F0',
  fontWeight: '500'
}

const modalStyleState = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: '60%',
  bgcolor: '#272727',
  fontFamily: 'Honeywell Sans Web',
  p: 4,
  borderRadius: '5px'
}

const ParameterListComponentStrings = LanguageStrings().AssetConfigurationStrings.components.AssetDetailsComponents.ParameterListComponent

export function getDeviceImage (device: any): string {
  // istanbul ignore else
  if (device != null) {
    if (DeviceUtil.getDeviceTypeByName(device)?.isWater === true) {
      if (DeviceUtil.getDeviceTypeByName(device)?.isQ600 === true) {
        return Q600
      } else if (DeviceUtil.getDeviceTypeByName(device)?.isHBG3 === true) {
        return HBG3
      } else if (DeviceUtil.getDeviceTypeByName(device)?.isV200H === true) {
        return V200H
      } else if (DeviceUtil.getDeviceTypeByName(device)?.isY290 === true) {
        return Y290
      } else if (DeviceUtil.getDeviceTypeByName(device)?.isTSherpaBridge === true) {
        return TSherpaBridge
      } else if (DeviceUtil.getDeviceTypeByName(device)?.isCz === true) {
        return Contazara
      }
      return Water_Merlin
    } else if (DeviceUtil.getDeviceTypeByName(device)?.isGas === true) {
      if (DeviceUtil.getDeviceTypeByName(device)?.isGasNxcm === true) {
        return GASNXCM
      } else if (DeviceUtil.getDeviceTypeByName(device)?.isEi6 === true) {
        return GASEI6
      } else if (DeviceUtil.getDeviceTypeByName(device)?.isEi7 === true) {
        return GASEI7
      } else if (DeviceUtil.getDeviceTypeByName(device)?.isGasAC250EI8 === true) {
        return AC250_NXS
      }
      return GASNXCM
    }
  }
  return DefaultImage
}

export function getDoublePageNotificationBadge (count: number): JSX.Element {
  return (
    <div className="double-page-notification-badge" data-testid='double-page-notification-badge'>
        <div className="double-page-badge-back"></div>
        <div className="double-page-badge">
            <span className="double-page-plus">+</span>
            <span className="double-page-number">{count}</span>
        </div>
    </div>
  )
}

const AssetSummary = (props: AllProps): JSX.Element => {
  const operationPermissions: OperationPermissionState = useSelector((state: RootState) => state.operationPermissions)
  const [showHistoryDetailsModal, setshowHistoryDetailsModal] = useState(false)
  const [previewImage] = useState<string | undefined>(undefined)
  const [showFullText, setShowFullText] = useState(false)
  const historyTableRef = useRef<HTMLDivElement | null>(null)
  const [isCarouselOpen, setIsCarouselOpen] = useState(false)
  const auth = useAuth()
  useEffect(() => {
    if (!operationPermissions.updated) {
      props.getOperationPermissions(auth.user?.profile.sub as string)
    }
  }, [])

  const handleToggleText = (): void => {
    setShowFullText(prev => !prev)
  }

  // istanbul ignore next
  const setRef = useCallback((node: HTMLDivElement | null) => {
    if (historyTableRef.current != null) {
      // Make sure to cleanup any events/references added to the last instance
      historyTableRef.current.removeEventListener('keydown', handleKeyDown)
    }

    if (node != null) {
      // Add event listeners or any instance specific tasks here
      node.addEventListener('keydown', handleKeyDown)
      node.focus()
    }

    // Save a reference to the node
    historyTableRef.current = node
  }, [])

  // istanbul ignore next
  const handleKeyDown = (e: KeyboardEvent): void => {
    if (e.key === 'ArrowDown') {
      historyTableRef.current?.scrollBy(0, 50)
    } else if (e.key === 'ArrowUp') {
      historyTableRef.current?.scrollBy(0, -50)
    }
  }

  const displayStateHistory = (): void => {
    setshowHistoryDetailsModal(true)
  }

  // istanbul ignore next
  const closedisplayStateHistory = (): void => {
    setshowHistoryDetailsModal(false)
  }

  function getImageDataUrlFromBase64 (base64String: string): string {
    return `data:image/jpeg;base64,${base64String}`
  }

  function getDefaultImageSource (): string {
    if ((previewImage?.includes('data:')) ?? false) {
      return previewImage ?? getDeviceImage(props.assetData?.assetData?.device_type)
    }
    if (previewImage != null) {
      return getImageDataUrlFromBase64(previewImage)
    }
    return getDeviceImage(props.assetData?.assetData?.device_type)
  }

  function handleCloseCarousel (): void {
    setIsCarouselOpen(false)
  }

  function getAssetImage (): JSX.Element {
    const assetImageState = props.assetPreviewImages.assetPreview
    const isAssetIdPresent = Object.prototype.hasOwnProperty.call(assetImageState, props.assetId)
    console.log('Asset ID:', props.assetId, 'isAssetIdPresent:', isAssetIdPresent)
    if (isAssetIdPresent) {
      const assetPreview = assetImageState[props.assetId]
      console.log('Asset Preview:', assetPreview)
      if (assetPreview.isLoading) {
        console.log('Asset image is loading...')
        return <CircularProgress data-testid='asset-image-circular-progress' size={'2rem'} />
      } else if (assetPreview.assetPreview.length > 0 && assetPreview.assetPreview[0].thumbnail.length > 0) {
        const image = assetPreview.assetPreview[0].thumbnail
        const doublaPageIcon = getDoublePageNotificationBadge(props.assetPreviewImages.assetPreview[props.assetId].assetPreview.length - 1)
        return (
          <div style={{ position: 'relative' }}>
            <img
              src={image}
              alt="Preview"
              style={{ width: '100px', height: 'auto' }}
            />
            {
              props.assetPreviewImages.assetPreview[props.assetId].assetPreview.length > 1 &&
              <span style={{
                display: 'inline-block',
                width: 'fit-content',
                position: 'absolute',
                top: '80%',
                right: '-18%',
                cursor: 'pointer'
              }}>
                {doublaPageIcon}
              </span>
            }
          </div>
        )
      } else {
        return <img
          src={getDefaultImageSource()}
          alt="Default Asset Image"
          data-testid='default-asset-image'
          style={{ width: '100px', height: 'auto' }}
        />
      }
    } else {
      return <img
        src={getDefaultImageSource()}
        alt="Default Asset Image"
        data-testid='default-asset-image'
        style={{ width: '100px', height: 'auto' }}
      />
    }
  }

  const CachedAssetImage = useMemo(getAssetImage, [props.assetPreviewImages, props.assetId])

  function renderModal (): JSX.Element {
    return <Modal className='Edit-AssetSummary-Modal deviceHistory-modal' open={showHistoryDetailsModal} onClose={() => { closedisplayStateHistory() }}>
        <Box sx={modalStyleState}>
        <div className='title' style={{ marginBottom: '30px' }}>
            <Typography id='modal-modal-title' variant='h6' component='h2'>
              {props.OverviewStrings.State_History}
            </Typography>
            <CloseIcon data-testid='Close-Button-Model'
              style={{ cursor: 'pointer' }}
              onClick={() => { closedisplayStateHistory() }}
            />
        </div>
        <div ref={setRef} tabIndex={0} style={{ maxHeight: '300px', overflowY: 'auto' }}>
          <table className='stateHistory-table' style={{ width: '100%', padding: '10px 5px 0 0' }}>
            <tbody>
              <tr>
                <th style={{ margin: '1em 0 0 0', fontSize: '14px', height: '40px', border: '1px solid #737373' }}>{ParameterListComponentStrings.FromState}</th>
                <th style={{ margin: '1em 0 0 0', fontSize: '14px', height: '40px', border: '1px solid #737373' }}>{ParameterListComponentStrings.ToState}</th>
                <th style={{ margin: '1em 0 0 0', fontSize: '14px', height: '40px', border: '1px solid #737373' }}>{ParameterListComponentStrings.TransitionDate}</th>
                <th style={{ margin: '1em 0 0 0', fontSize: '14px', height: '40px', border: '1px solid #737373' }}>{ParameterListComponentStrings.StateEndDate}</th>
                <th style={{ margin: '1em 0 0 0', fontSize: '14px', height: '40px', border: '1px solid #737373' }}>{ParameterListComponentStrings.UpdatedBy}</th>
              </tr>
              {
                props.deviceHistory.deviceHistory !== undefined
                  ? props.deviceHistory.deviceHistory.map((row: DeviceHistory, index: number) => (
                      <tr key={index}>
                        <td style={{ margin: '1em 0 0 0', fontSize: '14px', height: '40px', border: '1px solid #737373' }}>{row.state_from}</td>
                        <td style={{ margin: '1em 0 0 0', fontSize: '14px', height: '40px', border: '1px solid #737373' }}>{row.state_to}</td>
                        <td style={{ margin: '1em 0 0 0', fontSize: '14px', height: '40px', border: '1px solid #737373' }}>{row.transition_time !== null ? parseDateInAOHstandard(row.transition_time) : ''}</td>
                        <td style={{ margin: '1em 0 0 0', fontSize: '14px', height: '40px', border: '1px solid #737373' }}>{row.state_end_date !== null ? parseDateInAOHstandard(row.state_end_date) : ''}</td>
                        <td style={{ margin: '1em 0 0 0', fontSize: '14px', height: '40px', border: '1px solid #737373' }}>{row.user_details}</td>
                      </tr>
                  ))
                  : <></>
                }
            </tbody>
          </table>
        </div>
        </Box>
      </Modal>
  }

  function isFullPreviewAvailable (): boolean {
    const assetImageState = props.assetPreviewImages.assetPreview
    const assetId = props.assetId
    return Object.prototype.hasOwnProperty.call(assetImageState, assetId) &&
      assetImageState[assetId].assetPreview.length > 0
  }

  useEffect(() => {
    props.fetchDeviceHistory(props.assetId, auth.user?.profile.customer as string)
  }, [])

  if (props.assetData?.httpStatus === 401) {
    return (
      <div className="authError">
        <AuthError errorMessage="Unauthorized" />
      </div>
    )
  } else if (props.assetData?.httpStatus === 403) {
    return (
      <div className="authError">
        <AuthError errorMessage="accessForbidden" />
      </div>
    )
  } else {
    return (
    <Grid container style={{ paddingTop: '20px' }}>
      {
        isCarouselOpen && <AssetCarousel assetId={props.assetId} handleCloseCarousel={handleCloseCarousel} />
      }
      <Grid xs={12} sm={2}>
        <div
          style={{
            padding: '10px',
            backgroundColor: 'white',
            height: 'fit-content',
            borderRadius: '10px',
            width: 'fit-content'
          }}
        >
          <span className='asset-image-preview' data-testid='asset-image-preview' onClick={() => {
            if (isFullPreviewAvailable()) {
              setIsCarouselOpen(true)
              if (props.assetPreviewImages.assetPreview[props.assetId].assetPreview[0].image.length === 0) {
                props.fetchAssetImageByName(props.assetId, props.assetPreviewImages.assetPreview[props.assetId].assetPreview[0].name)
              }
            }
          }}>
            {CachedAssetImage}
          </span>
        </div>
      </Grid>
      <Grid container xs={12} sm={10}>
        <Grid container className='assetSummaryRow'>
          <Grid item xs={12} sm={3}>
            <Grid className='assetSummaryListHead'>{props.OverviewStrings.Asset_Type}</Grid>
            <Grid className='assetSummaryListContent'>
              {props.assetData?.assetData?.device_type}
            </Grid>
          </Grid>
          <Grid item xs={12} sm={3}>
          <Grid className='assetSummaryListHead'>{props.OverviewStrings.State}</Grid>
            <Grid className='assetSummaryListContent' style={assetValuesStyles}>{props.assetData?.assetData?.asset_state} <span style={{ color: '#64C3FF', cursor: 'pointer' }} onClick={() => { displayStateHistory() }} data-testid= "view-history">({ParameterListComponentStrings.ViewHistory})</span></Grid>
          </Grid>
          <Grid item xs={12} sm={3}>
            <Grid className='assetSummaryListHead'>{props.OverviewStrings.Year_of_Certification}</Grid>
            <Grid className='assetSummaryListContent'>{props.OverviewStrings.None}</Grid>
          </Grid>
          <Grid item xs={12} sm={3}>
            <Grid className='assetSummaryListHead'>{props.OverviewStrings.Tag}</Grid>
            <Grid className='assetSummaryListContent'>{props.assetData?.assetData?.tag[0]?.name !== null && props.assetData?.assetData?.tag[0]?.name !== undefined && props.assetData?.assetData?.tag[0]?.name !== '' ? props.assetData?.assetData?.tag[0]?.name : ParameterListComponentStrings.NotAvailable } </Grid>
          </Grid>
        </Grid>
        <Grid container className='assetSummaryRow'>
          {/* <Grid item xs={12} sm={3}>
            <Grid className='assetSummaryListHead'>{props.OverviewStrings.Asset_Configuration}</Grid>
            <Grid className='assetSummaryListContent'>None</Grid>
          </Grid> */}
          <Grid item xs={12} sm={3}>
            <Grid className='assetSummaryListHead'>{props.OverviewStrings.Serial_Number}</Grid>
            <Grid className='assetSummaryListContent' style={assetValuesStyles}>{props.assetData?.assetData?.comm_mod_serial ?? ParameterListComponentStrings.Not_Applicable}</Grid>
          </Grid>
          <Grid item xs={12} sm={3}>
            <Grid className='assetSummaryListHead'>{props.OverviewStrings.Installation_Date}</Grid>
            <Grid className='assetSummaryListContent'>
              {props.assetData?.assetData?.install_date !== null &&
              props.assetData?.assetData?.install_date !== undefined
                ? convertDateIntoAohStandardInUTC(
                  props.assetData?.assetData?.install_date
                )
                : '----'}
            </Grid>
          </Grid>
          <Grid item xs={12} sm={3}>
            <Grid className='assetSummaryListHead'>{props.OverviewStrings.Meter_Serial_Number}</Grid>
            <Grid className='assetSummaryListContent'>
              {props.assetData?.assetData?.serial_number}
            </Grid>
          </Grid >
          {(((props.assetData?.assetData?.device_type.startsWith('Water')) === true) || ((props.assetData?.assetData?.device_type.startsWith('Gas')) === true)) && (
          <>
              <Grid item xs={12} sm={3}>
                  <Grid className='assetSummaryListHead'>{props.OverviewStrings.Meter_Date_of_Expiry}</Grid>
                  <Grid className='assetSummaryListContent'>
                    {props.OverviewStrings.None}
                  </Grid>
                </Grid>
          </>
          )}
        </Grid>
        <Grid container className='assetSummaryRow'>
        {(((props.assetData?.assetData?.device_type.startsWith('Water')) === true) || ((props.assetData?.assetData?.device_type.startsWith('Gas')) === true)) && (
          <>
                <Grid item xs={12} sm={3}>
                  <Grid className='assetSummaryListHead'>{ParameterListComponentStrings.RemainingBatteryPercentage}</Grid>
                  <Grid className='assetSummaryListContent'>
                  {((props.assetData?.assetData?.rem_bat_percent) != null) ? props.assetData?.assetData?.rem_bat_percent?.toString() : ParameterListComponentStrings.NotAvailable}
                  </Grid>
                </Grid>
                <Grid item xs={12} sm={3}>
                <Grid className='assetSummaryListHead'>{props.OverviewStrings.Meter_Date_of_Shipment}</Grid>
                  <Grid className='assetSummaryListContent'>
                    {props.OverviewStrings.None}
                  </Grid>
                </Grid>
                <Grid item xs={12} sm={3}>
                  <Grid className='assetSummaryListHead'>{props.OverviewStrings.Firmware_Version}</Grid>
                  <Grid className='assetSummaryListContent'>
                    {props.assetData?.assetData?.firmware_version !== null ? props.assetData?.assetData?.firmware_version : ParameterListComponentStrings.NotAvailable}
                  </Grid>
                </Grid>
                <Grid item xs={12} sm={3}>
                  <Grid className='assetSummaryListHead'>{props.OverviewStrings.IP_Port}</Grid>
                      <div style={{ display: 'flex', alignItems: 'center' }}>
                        <span className='assetSummaryListContent' style={{ display: 'flex', flexDirection: 'column', position: 'relative' }}>
                        { props.assetData?.assetData?.ip_address !== null && props.assetData?.assetData?.ip_address !== '' ? props.assetData?.assetData?.ip_address : ParameterListComponentStrings.NotAvailable } : { props.assetData?.assetData?.port !== null && props.assetData?.assetData?.port !== '' ? props.assetData?.assetData?.port : ParameterListComponentStrings.NotAvailable }
                        </span>
                      </div>
                </Grid>
          </>
        )}
        </Grid>
        <Grid container className='assetSummaryRow'>
          {(((props.assetData?.assetData?.device_type.startsWith('Water')) === true) || ((props.assetData?.assetData?.device_type.startsWith('Gas')) === true)) && (
                <>
              <Grid item xs={12} sm={3}>
                  <Grid className='assetSummaryListHead'>{ParameterListComponentStrings.TowerId}</Grid>
                  <Grid className='assetSummaryListContent'>
                    {((props.assetData?.assetData?.towerId) != null) ? props.assetData?.assetData?.towerId : ParameterListComponentStrings.NotAvailable}
                  </Grid>
                </Grid>
                <Grid item xs={12} sm={3}>
                <Grid className='assetSummaryListHead'>{ParameterListComponentStrings.ExtendedCoverageMode}</Grid>
                <Grid className='assetSummaryListContent'>
                      {((props.assetData?.assetData?.extended_coverage_mode) != null) ? props.assetData?.assetData?.extended_coverage_mode : ParameterListComponentStrings.NotAvailable}
                </Grid>
                </Grid>
                <Grid item xs={12} sm={3}>
                    <Grid className='assetSummaryListHead'>{ParameterListComponentStrings.CommType}</Grid>
                    <Grid className='assetSummaryListContent'>
                        {((props.assetData?.assetData?.comm_type) != null) ? props.assetData?.assetData?.comm_type : ParameterListComponentStrings.NotAvailable}
                    </Grid>
                </Grid>
            </>

          )}
        </Grid>

        <div style={{
          width: '1608px',
          height: '2px',
          backgroundColor: '#202020'
        }} />

        <Grid container className='assetSummaryRow' style={{ paddingTop: '20px' }}>
          {(
              <>
                <Grid item xs={12} sm={3}>
                  <Grid className='assetSummaryListHead'>{ParameterListComponentStrings.DisconnectControlState}</Grid>
                  <Grid className='assetSummaryListContent'>
                    {((props.assetData?.assetData?.disconnect_control_state) != null) ? props.assetData?.assetData?.disconnect_control_state : ParameterListComponentStrings.NotAvailable}
                  </Grid>
                </Grid>
                <Grid item xs={12} sm={3}>
                  <Grid className='assetSummaryListHead'>{ParameterListComponentStrings.DisconnectOutputState}</Grid>
                  <Grid className='assetSummaryListContent'>
                    {((props.assetData?.assetData?.disconnect_output_state) != null) ? props.assetData?.assetData?.disconnect_output_state : ParameterListComponentStrings.NotAvailable}
                  </Grid>
                </Grid>
                <Grid item xs={12} sm={3}>
                  <Grid className='assetSummaryListHead'>{ParameterListComponentStrings.TauTimer}</Grid>
                  <Grid className='assetSummaryListContent'>
                    {((props.assetData?.assetData?.tau_timer) != null) ? props.assetData?.assetData?.tau_timer : ParameterListComponentStrings.NotAvailable}
                  </Grid>
                </Grid>
                <Grid item xs={12} sm={3}>
                  <Grid className='assetSummaryListHead'>{ParameterListComponentStrings.BatteryInUse}</Grid>
                  <Grid className='assetSummaryListContent'>
                    {((props.assetData?.assetData?.battery_in_use) != null) ? props.assetData?.assetData?.battery_in_use : ParameterListComponentStrings.NotAvailable}
                  </Grid>
                </Grid>
              </>
          )}
        </Grid>

        <Grid container className='assetSummaryRow'>
          {(
              <>
                <Grid item xs={12} sm={3}>
                  <Grid className='assetSummaryListHead'>{ParameterListComponentStrings.Battery0EstimatedRemainingUseTime}</Grid>
                  <Grid className='assetSummaryListContent'>
                    {((props.assetData?.assetData?.battery_0_estimated_remaining_use_time) != null) ? props.assetData?.assetData?.battery_0_estimated_remaining_use_time : ParameterListComponentStrings.NotAvailable}
                  </Grid>
                </Grid>
                <Grid item xs={12} sm={3}>
                  <Grid className='assetSummaryListHead'>{ParameterListComponentStrings.Battery1EstimatedRemainingUseTime}</Grid>
                  <Grid className='assetSummaryListContent'>
                    {((props.assetData?.assetData?.battery_1_estimated_remaining_use_time) != null) ? props.assetData?.assetData?.battery_1_estimated_remaining_use_time : ParameterListComponentStrings.NotAvailable}
                  </Grid>
                </Grid>
              </>
          )}
        </Grid>

        <div style={{
          width: '1608px',
          height: '2px',
          backgroundColor: '#202020'
        }} />
        { props.assetData?.assetData !== null && props.assetData?.assetData !== undefined && (
        <Grid container className='assetSummaryRow' style={{ paddingTop: '20px' }}>
          <Grid item xs={12} sm={3}>
            <Grid className='assetSummaryListHead'>{props.OverviewStrings.Installation_Remarks}</Grid>
            <Grid className='assetSummaryListContent'>
              {(props.assetData?.assetData?.installation_remarks !== null && props.assetData?.assetData?.installation_remarks !== '') ? (
                <>
                  {showFullText || props.assetData?.assetData.installation_remarks.length <= 56
                    ? props.assetData?.assetData.installation_remarks
                    : props.assetData?.assetData.installation_remarks.slice(0, 56)}
                    {props.assetData?.assetData.installation_remarks.length > 56 && (
                      <span
                        style={{ cursor: 'pointer', color: '#64C3FF', whiteSpace: 'nowrap' }}
                        onClick={handleToggleText}
                      >
                      {showFullText
                        ? <span style={{ marginLeft: 4 }}>
                            {ParameterListComponentStrings.less}
                          </span>
                        : `...${ParameterListComponentStrings.more}`}
                      </span>
                    )}
                </>
              ) : ParameterListComponentStrings.NotAvailable}
            </Grid>
          </Grid>
        </Grid>
        )}
        {
          renderModal()
        }
        {((props.assetPropertiesData?.propertiesData?.properties) != null) &&
          Array.isArray(props.assetPropertiesData.propertiesData.properties) &&
          props.assetPropertiesData.propertiesData.properties.length > 0 ? (
            <>
              <div style={{
                width: '1608px',
                height: '2px',
                backgroundColor: '#202020'
              }} />
              <div style={{
                position: 'relative',
                paddingTop: '50px'
              }}>
                <Grid container className='assetSummaryRow' style={{
                  padding: '40px 20px 20px 20px',
                  borderRadius: '8px',
                  backgroundColor: '#404040',
                  color: '#ffffff',
                  ...(props.assetPropertiesData.propertiesData.properties.length < 3 && {
                    minHeight: '270px' // Only apply minHeight when items < 3
                  }),
                  ...(props.assetPropertiesData.propertiesData.properties.length <= 3 && {
                    minWidth: '500px'
                  })

                }}>
                  <div style={{
                    position: 'absolute',
                    top: '30px',
                    left: '20px'
                  }}>
                    <Button
                      variant="contained"
                      style={{
                        backgroundColor: '#272727',
                        color: '#B0B0B0',
                        border: '#101010 1px solid',
                        padding: '5px 8px',
                        fontWeight: '800',
                        fontSize: '14px',
                        textTransform: 'none',
                        borderRadius: '4px',
                        boxShadow: 'none'
                      }}
                    >
                      {ParameterListComponentStrings.Asset_Details}
                    </Button>
                  </div>
                  <Grid container spacing={props.assetPropertiesData.propertiesData.properties.length < 3 ? 11 : 2}>
                    {props.assetPropertiesData?.propertiesData?.properties.map((property, index) => (
                      <Grid item xs={12} sm={3} key={index} style={{
                        marginBottom: '20px'
                      }}>
                        <Grid className='assetSummaryListHead' style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                          {
                            (property.attribute_name !== null && property.attribute_name.trim() !== '')
                              ? property.attribute_name.length > 12
                                ? <abbr title={property.attribute_name} style={{ textDecoration: 'none' }}>{property.attribute_name}</abbr>
                                : property.attribute_name
                              : ParameterListComponentStrings.NotAvailable
                          }
                        </Grid>
                        <Grid className='assetSummaryListContent' style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                          {
                            (property.value !== null && property.value.trim() !== '')
                              ? property.value.length > 12
                                ? <abbr title={property.value} style={{ textDecoration: 'none' }}>{property.value}</abbr>
                                : property.value
                              : ParameterListComponentStrings.NotAvailable
                          }
                        </Grid>
                      </Grid>
                    ))}
                  </Grid>
                </Grid>
              </div>
            </>
            ) : <></>}
        <Grid
          style={{
            marginTop: '20px',
            marginBottom: '20px',
            paddingTop: '20px',
            paddingBottom: '20px'
          }}
          container
        >
        </Grid>
      </Grid>
    </Grid>
    )
  }
}

interface DispatchToProps {
  fetchAssetData: (id: string, tenantId: string) => void
  getOperationPermissions: (sub: string) => void
  fetchDeviceHistory: (assetId: string, tenantId: string) => void
  fetchAssetImageByName: (assetId: string, name: string) => void
}

const mapDispatchToProps = (dispatch: any): DispatchToProps => ({
  fetchAssetData: (id: string, tenantId: string) => dispatch(fetchAssetData(id, tenantId)),
  getOperationPermissions: (sub: string) => dispatch(getOperationPermissions(sub)),
  fetchDeviceHistory: (assetId: string, tenantId: string) => dispatch(fetchDeviceHistory(assetId, tenantId)),
  fetchAssetImageByName: (assetId: string, name: string) => dispatch(fetchAssetImageByName(assetId, name))
})

interface StateToProps {
  ipConfigState: IPConfigState
  deviceHistory: DeviceHistoryState
  assetPreviewImages: AssetPreviewDataState
}

const mapStateToProps = (state: RootState): StateToProps => ({
  ipConfigState: state.ipConfigState,
  deviceHistory: state.deviceHistory,
  assetPreviewImages: state.assetPreviewImages
})

const connector = connect(mapStateToProps, mapDispatchToProps)
type PropsFromRedux = ConnectedProps<typeof connector>

interface ParentProps {
  assetData: AssetByIdState
  OverviewStrings: any
  assetId: string
  assetPropertiesData: AssetPropertiesByIdState
}

type AllProps = PropsFromRedux & ParentProps

export default connector(AssetSummary)
